import { NgClass, NgOptimizedImage } from '@angular/common';
import { Component, inject, input } from '@angular/core';
import { MatRippleModule } from '@angular/material/core';
import { TranslateModule } from '@ngx-translate/core';
import { Footer } from 'app/core/models/footer.model';
import { CmsMediaPrefixPipe } from 'app/core/pipes/cms-media-prefix.pipe';
import { ShebaGtmModule } from 'app/core/services/google-tag-manager/gtm.directive';
import { SharedService } from 'app/core/services/shared.service';
import { RouterLinkDetectorDirective } from '../../directives/router-link-detector.directive';

@Component({
  selector: 'sheba-logo-link',
  template: `<a
    class="relative h-[3.25rem] w-[8.125rem] self-center rounded-xl md:ms-[3.375rem]"
    [href]="footerData().logoLink?.url"
    [attr.target]="footerData().logoLink?.target"
    [attr.aria-description]="footerData().logoLink?.title"
    [shebaGtmClick]="{ user_action: 'user_clicks_footer' }"
    routerLinkDetector
    cdkMenuItem
    matRipple
  >
    @if (footerData().logo && footerData().logo.image) {
      <img
        class="h-full"
        [ngSrc]="footerData().logo.image!.url | cmsMediaPrefix"
        [alt]="footerData().logo.alt ?? ''"
        [title]="footerData().logo.title ?? ''"
        [ngClass]="{ 'brightness-0 invert': !lightMode() }"
        fill
      />
    }
  </a>`,
  host: {
    class: 'contents'
  },
  standalone: true,
  imports: [
    MatRippleModule,
    CmsMediaPrefixPipe,
    TranslateModule,
    RouterLinkDetectorDirective,
    NgClass,
    NgOptimizedImage,
    ShebaGtmModule
  ]
})
export class ShebaLogoLinkComponent {
  footerData = input<Footer>({} as Footer);
  lightMode = inject(SharedService).lightMode;
}
